import React, { Component } from 'react'

import DecimalFormatSettings from './DecimalFormatSettings'

class DefDossierDefFieldDecimalSettings extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <div>
                <h5>{this.props.kedo.t('Additional settings')}</h5>
                <DecimalFormatSettings
                    item={this.props.item}
                    kedo={this.props.kedo}
                    onChange={this.props.onChange}
                />
            </div>
        )
    }
}

export default DefDossierDefFieldDecimalSettings
